export const brand = {
  name: 'sls',
  domain: 'sls.assess-sls.etrainu.com',
  showOrgSwitch: false
};
